'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _easing = require('./easing');

var _easing2 = _interopRequireDefault(_easing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jump = function jump() {
  var target = void 0; //  (node|number|cssSelector)
  var element = void 0; //  (node)
  var start = void 0; //  (px)
  var stop = void 0; //  (px)
  var offset = void 0; //  (px)
  var easing = void 0; //  (function)
  var a11y = void 0; //  (boolean)
  var distance = void 0; //  (px)
  var duration = void 0; //  (ms)
  var timeStart = void 0; //  (ms)
  var timeElapsed = void 0; //  (ms)
  var next = void 0; //  (px)
  var callback = void 0; //  (function)
  var windowObj = void 0; //  (window object|iFrame window)

  function location() {
    return windowObj.scrollY || windowObj.pageYOffset;
  }

  function top(el) {
    return el.getBoundingClientRect().top + start;
  }

  function done() {
    // account for rAF time rounding inaccuracies
    windowObj.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // rAF loop helper
  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    windowObj.scrollTo(0, next);

    if (timeElapsed < duration) {
      window.requestAnimationFrame(loop); // continue scroll loop
    } else {
      done();
    }
  }

  function jumpTo() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    target = options.target;
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback;
    easing = options.easing || _easing2.default;
    a11y = options.a11y || false;
    windowObj = options.windowObj || window; // canvas hack (expect iframe window object)
    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined;
        a11y = false;
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;

      default:
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    switch (_typeof(options.duration)) {
      // ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;

      default:
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  return jumpTo;
};

var singleton = jump();

exports.default = singleton;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/in-page-anchors/js/jump.js
// module id = 1105
// module chunks = 4